import { FormAtylBase } from '../../form-atyl-base'

export class AtylSection extends FormAtylBase<string> {
	controlType = 'section'
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
